import { create } from "zustand";
import { getClients } from "../services/api";

const useAdminClientStore = create((set, get) => ({
	clients: [],
	hydrated: false,
	loading: false,
	error: "",

	hydrateClients: async () => {
		if (get().loading || get().hydrated) {
			return;
		}

		set({ loading: true, error: "" });

		try {
			const data = await getClients();
			set({
				clients: Array.isArray(data) ? data : [],
				hydrated: true,
				loading: false,
				error: "",
			});
		} catch (err) {
			set({
				clients: [],
				hydrated: false,
				loading: false,
				error: err?.message || "Failed to load clients",
			});
		}
	},

	resetClients: () =>
		set({
			clients: [],
			hydrated: false,
			loading: false,
			error: "",
		}),
}));

export default useAdminClientStore;
